// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";

// LPConfirmETHResponse acknowledges the ETH confirmation.
@jsonObject()
export default class LPConfirmETHResponse extends PerunMessage {
  @jsonMember(Boolean) ok: boolean;

  constructor(ok = false) {
    super();
    this.ok = ok;
  }

  messageType(): MessageType {
    return LPConfirmETHResponse;
  }

  messageTypeName(): MessageTypeName {
    return "LPConfirmETHResponse";
  }
}
